import styled from 'styled-components';

import { InputContainer } from '@components/Input';
import { FlexibleDiv } from '@components/formStyles';

import { Button } from '../../common/styled';

export const DynamicDiv = styled.div<{ spaceBetween?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;

  ${({ spaceBetween }) => spaceBetween && 'justify-content: space-between'};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const Content = styled.div`
  margin: 40px 0 0;
  font-size: 16px;
  line-height: 1.56;
  color: ${(p) => p.theme.palette.darkGray};
`;

export const Section = styled.section`
  margin: 32px 0 40px;
  display: flex;
  button {
    height: unset;
    width: 148px;
    font-weight: bold;
  }
  column-gap: 20px;
  ${InputContainer} {
    flex: 1;
  }
`;

export const Paragraph = styled.p`
  font-size: 14px;
  line-height: 1.57;
  color: ${(p) => p.theme.palette.darkGrey};
`;

export const Bold = styled.span`
  font-weight: bold;
`;

export const LogoWrapper = styled.div`
  width: auto;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
  }
`;

export const MainWrapper = styled.div`
  width: 75%;
  height: auto;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
  }
`;

export const HopiWrapper = styled.div`
  width: 25%;
  height: 253px;
  display: inline-flex;
  justify-content: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  margin-left: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 20px;
    margin-left: 0;
  }
`;

export const StyledButton = styled(Button)`
  width: 250px;
  height: 60px;
`;

export const StyledFlexibleDiv = styled(FlexibleDiv)`
  align-items: center;
  display: flex;
  width: 100%;
`;
